// extracted by mini-css-extract-plugin
export var accordion = "CookiesSettingsAccordion-module--accordion--ffb34";
export var accordionExpand = "CookiesSettingsAccordion-module--accordionExpand--d6b1d";
export var accordionInput = "CookiesSettingsAccordion-module--accordionInput--1cf54";
export var accordionTitle = "CookiesSettingsAccordion-module--accordionTitle--6bc5a";